var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyApprovals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 16.1667C14.0001 16.3214 14 16.5 14 16.5792C14 16.5 14 16.75 14 16.75H0.000224408V16.5C0.000224408 16.5 6.49057e-05 16.3214 6.49057e-05 16.1667C6.49057e-05 16.012 0 16 0 16L0.000182945 15.5834L14.0001 15.5834C14.0001 15.5834 14 15.5 14 15.7542C14 16 14.0001 16.012 14.0001 16.1667ZM14.0001 10.3334V13.25C14.0001 13.5594 14.0001 14 14.0001 14C14.0001 14 13.3095 14 13 14H1.16673C0.857312 14 0.500033 14 0.000155073 14C3.30016e-05 13.9251 6.49057e-05 13.5594 6.49057e-05 13.25V10.3334C6.49057e-05 10.0239 0.000191089 10 0.000269514 9.50839C0.000269514 9.50002 0.000120159 9.16668 0.000120159 9.16668L5.11152 9.16668L4.00006 3.00002C4.50006 2.00002 4.50006 2.00002 5.00006 1.00002C4.65212 0.999917 5.24349 1.00002 5.00006 1.00002L9.00006 1.00002C9.34801 0.999916 8.99615 1.00002 8.99615 1.00002C8.99615 1.00002 8.91919 0.661601 9.00006 1.00002C10.0001 3.00002 10.0001 3.00002 10.0001 3.00002L8.88861 9.16668H14.0001C14.0001 9.16668 14.0001 9.50002 14.0001 9.50839C14.0001 10 14.0001 10.0239 14.0001 10.3334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyApprovals);
export default __webpack_public_path__ + "static/media/MyApprovals.d6e385a6e84861f61fdbad492005d6e8.svg";
export { ForwardRef as ReactComponent };